export default __webpack_public_path__ + "static/media/cao-e-gato@3x_2.21b1ef44.jpg";